// ============================================================================
// AVP CHART CREATE
// ============================================================================

export const AVP_CHART_CREATE_KEY = 'avp_chart_create';

export type AvpChartCreateActionPayload = {
	/**
	 * The ARI of the AVP dashboard to create the chart on.
	 */
	dashboardAri: string;
	/**
	 * The chart data containing chart configuration and canvas layout.
	 */
	chartData: {
		/**
		 * The chart configuration.
		 */
		chart: any;
		/**
		 * The canvas layout configuration.
		 */
		canvasLayout: any;
	};
};

export function isAvpChartCreateActionData(data: unknown): data is AvpChartCreateActionPayload {
	if (typeof data !== 'object' || data === null) {
		return false;
	}
	const d = data as Record<string, unknown>;
	const chartData = d.chartData;
	if (typeof chartData !== 'object' || chartData === null) {
		return false;
	}
	const cd = chartData as Record<string, unknown>;
	return (
		typeof d.dashboardAri === 'string' &&
		typeof cd.chart === 'object' &&
		cd.chart !== null &&
		typeof cd.canvasLayout === 'object' &&
		cd.canvasLayout !== null
	);
}

// ============================================================================
// AVP DASHBOARD CREATE
// ============================================================================

export const AVP_DASHBOARD_CREATE_KEY = 'avp_dashboard_create';

export type AvpDashboardCreateActionPayload = {
	/**
	 * The URL of the AVP dashboard.
	 */
	dashboardUrl: string;
	/**
	 * The ARI of the AVP dashboard.
	 */
	dashboardAri: string;
};

export function isAvpDashboardCreateActionData(
	data: unknown,
): data is AvpDashboardCreateActionPayload {
	if (typeof data !== 'object' || data === null) {
		return false;
	}
	const d = data as Record<string, unknown>;
	return typeof d.dashboardUrl === 'string' && typeof d.dashboardAri === 'string';
}

// ============================================================================
// AVP ACTION CLASSIFICATION
// ============================================================================

const AVP_CREATABLE_ACTION_KEYS = new Set([AVP_CHART_CREATE_KEY, AVP_DASHBOARD_CREATE_KEY]);

const AVP_PREVIEW_CARD_ACTION_KEYS = new Set([AVP_DASHBOARD_CREATE_KEY]);

export const isAvpPreviewCardAction = (action: { key: string }): boolean =>
	AVP_PREVIEW_CARD_ACTION_KEYS.has(action.key);

export const isAvpCreatableAction = (action: { key: string }): boolean =>
	AVP_CREATABLE_ACTION_KEYS.has(action.key);

export const isAvpStreamAction = (action: { key: string }): boolean => isAvpCreatableAction(action);
